/**
 * Top-bar dismiss (localStorage).
 */
(function () {
	const STORAGE_KEY = 'didapress_de_relaunch_2026_topbar_dismissed';

	function dismiss(bar) {
		const id = bar.getAttribute('data-top-bar-dismiss-id');
		if (!id) {
			return;
		}
		try {
			localStorage.setItem(STORAGE_KEY, id);
		} catch (e) {
			// Ignore quota / private mode errors.
		}
		bar.hidden = true;
		bar.classList.add('is-dismissed');
		document.documentElement.classList.add('top-bar-is-dismissed');
	}

	function init() {
		document.querySelectorAll('.top-bar[data-top-bar-dismiss-id]').forEach(function (bar) {
			const id = bar.getAttribute('data-top-bar-dismiss-id');
			if (!id) {
				return;
			}

			try {
				if (localStorage.getItem(STORAGE_KEY) === id) {
					bar.hidden = true;
					bar.classList.add('is-dismissed');
					document.documentElement.classList.add('top-bar-is-dismissed');
					return;
				}
			} catch (e) {
				// Continue without stored state.
			}

			const closeBtn = bar.querySelector('.top-bar__close');
			if (!closeBtn) {
				return;
			}

			closeBtn.addEventListener('click', function () {
				dismiss(bar);
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
